var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHandshake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 79,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.4%",
    y: "-3.7%",
    width: "108.8%",
    height: "110.4%",
    filterUnits: "objectBoundingBox",
    id: "icon-handshake_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-handshake_svg__a)",
    transform: "translate(-98 -72)",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.8 79l13.724 13.724a1.622 1.622 0 010 2.297l-15.502 15.503a1.624 1.624 0 01-2.297 0L105 96.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 110.27l2.262 2.261a1.598 1.598 0 002.261 0l13.008-13.006a1.6 1.6 0 000-2.263L136.27 95 121 110.27z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 129.035A.157.157 0 00139 129l-1 1 .958-.965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.058 129.667c-1.27 1.271-3.342 1.271-4.598 0a.898.898 0 00.114.129c1.042 1.284.957 3.184-.227 4.354a3.248 3.248 0 01-4.597 0l-1.157-1.142a3.251 3.251 0 01-4.596 4.598l-.915-.913a3.26 3.26 0 01-.229 4.354 3.249 3.249 0 01-4.597 0l-1.885-1.886.7-.642a3.253 3.253 0 00.216-4.597 3.234 3.234 0 00-4.583-.214l-.944.857-.056-.057 1.127-1.028a3.252 3.252 0 00.214-4.598 3.224 3.224 0 00-4.482-.3l.157-.142a3.253 3.253 0 00.215-4.597 3.236 3.236 0 00-4.584-.215l-.8.729s0-.015-.014-.029l.743-.672c1.327-1.199 1.412-3.254.214-4.582-1.086-1.185-2.855-1.399-4.154-.543l-.087-.085-6.253-6.24L138.207 99c3.783 3.441 7.409.572 11.036 2.927l-6.953 3.597a3.243 3.243 0 00-1.385 4.384c.828 1.585 2.799 2.213 4.383 1.385l6.467-3.47 15.447 14.549 2.856 2.699a3.275 3.275 0 010 4.596zM181.858 77L166.47 92.63a1.653 1.653 0 000 2.31l15.341 15.582a1.59 1.59 0 002.273 0L199 95.369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 110.265l-2.263 2.261a1.586 1.586 0 01-2.261 0l-.084-.085-9.78-9.76a4.48 4.48 0 01-.24-.252l-2.909-2.907a1.611 1.611 0 010-2.26L166.726 95 182 110.265z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 112.939L167.085 123l-15.055-14.47-.057.03-6.326 3.443c-1.548.823-3.477.199-4.287-1.374-.81-1.587-.21-3.529 1.355-4.35l6.801-3.572h.014l.657-.354a9.59 9.59 0 016.382-.893l.041.014a9.612 9.612 0 005.935-.68l1.705-.794 2.667 2.707c.07.085.154.17.237.255 3.352 3.57 8.66 9.14 9.72 9.849l.084.085.042.043z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11 99l2.89 3-3-2.953.11-.047zM177.163 112.082l-.041.041-.041-.041L177 112c.081.055.136.082.163.082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.983 123.587l-.714.665-2.032 1.907c-1.277 1.201-3.253 1.103-4.42-.212-1.167-1.314-1.07-3.348.206-4.536l2.746-2.571a2.26 2.26 0 01.426-.325c1.248-.847 2.95-.636 3.994.536 1.153 1.315 1.07 3.35-.206 4.536zM144.898 133.436l-1.167.987-2.1 1.767c-1.374 1.15-3.502 1.069-4.76-.205-1.211-1.247-1.152-3.152.134-4.317l1.996-1.698 1.418-1.193.06-.04c1.374-1.083 3.415-.96 4.64.287 1.258 1.274 1.155 3.247-.22 4.412z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 130l-2 2c.015-.049.06-.081.089-.113L139 130zM139 129l-1 1 .958-.965A.146.146 0 00139 129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.916 138.852l-.713.664-.668.606a3.263 3.263 0 01-4.67-.222 3.399 3.399 0 01.218-4.753l.422-.383.96-.886a3.262 3.262 0 014.67.222 3.397 3.397 0 01-.219 4.752zM139.923 128.41l-.16.135-.057.042c-.015.013-.03.027-.06.041l-1.329 1.146-1.866 1.596c-.028.027-.072.054-.087.096l-.853.722c-1.345 1.16-3.427 1.064-4.656-.204-1.215-1.27-1.128-3.234.217-4.38l3.615-3.096.809-.696c1.346-1.16 3.428-1.065 4.643.205 1.23 1.268 1.128 3.232-.216 4.392z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.089 131.887L139 130l-2 2c.015-.049.06-.081.089-.113zM139 129l-1 1 .958-.965A.146.146 0 00139 129zM157 131l2 2M162 126l4 4M153 135l2 2"
  }))));
}
export default SvgIconHandshake;